export default "__VITE_ASSET__DuJNzsBF__"